import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from "react";

import { ThemeProvider as StyledThemeProvider, DefaultTheme } from "styled-components";

import dark from "@/styles/themes/dark";

interface ThemeContextData {
  setTheme: Dispatch<SetStateAction<DefaultTheme>>;
  theme: DefaultTheme;
}

export const ThemeContext = createContext({} as ThemeContextData);

interface ThemeProviderProps {
  primary?: string;
  children: ReactNode;
}

export default function ThemeProvider({
  primary = dark.primary,
  children,
}: ThemeProviderProps) {
  const [theme, setTheme] = useState({ ...dark, primary });

  useEffect(() => setTheme({ ...dark, primary }), [primary]);

  return (
    <ThemeContext.Provider value={{ setTheme, theme }}>
      <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
    </ThemeContext.Provider>
  );
}
